module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.already) ? _c('a', {
    staticClass: "paper-active",
    on: {
      "click": _vm.enterPaper
    }
  }, [_vm._v("开始估分")]) : _c('span', {
    staticClass: "paper-active"
  }, [_vm._v(_vm._s(_vm.diffTime))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26b0c77c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CountDown.vue
// module id = 473
// module chunks = 1